document.addEventListener('DOMContentLoaded', () => {
    const controlButton = document.querySelector('.how-we-started__controls');
    const videoElement = document.querySelector('.how-we-started__video video');

    // Safety check: ensure both elements exist on the page before adding the listener
    if (controlButton && videoElement) {
        controlButton.addEventListener('click', () => {
            // Toggle the muted property (true becomes false, false becomes true)
            videoElement.muted = !videoElement.muted;
            
            console.log('video clicked. Muted:', videoElement.muted);
        });
    }
});